import { gql } from 'src/__generated__'

export default gql(`
  mutation verifyAccountConfirm($data: VerifyAccountConfirmInput!) {
    verifyAccountConfirm(data: $data)
  }
`)
